import Api from "..";

const getRegioes = async (useFilter = false) => {
    try {
        const idUsuario = typeof window !== 'undefined' ? localStorage.getItem('idUsuario') : null;
    const url = (useFilter && idUsuario) ? `regiao/listarRegioes?idUsuario=${idUsuario}` : 'regiao/listarRegioes';
        const response = await Api.get(url);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar regiões: ${error.message}`);
    }
};

const getRegiaoById = async (id) => {
    try {
        const response = await Api.get(`/regiao/buscarRegiaoPorId?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar região com ID ${id}: ${error.message}`);
    }
};

const createRegiao = async (regiaoData) => {
    try {
        const response = await Api.post("/regiao/criarRegiao", regiaoData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao criar região: ${error.message}`);
    }
};

const updateRegiao = async (id, regiaoData) => {
    try {
        const response = await Api.patch(`/regiao/atualizarRegiao?id=${id}`, regiaoData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao atualizar região com ID ${id}: ${error.message}`);
    }
};

const deleteRegiao = async (id) => {
    try {
        const response = await Api.delete(`/regiao/deletarRegiao?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao deletar região com ID ${id}: ${error.message}`);
    }
};

const listar = async () => {
    try {
        const response = await Api.get('regiao/listarRegioes');
        return response.data;
    } catch (error) {
        throw error.response?.data || { erro: 'Erro ao buscar regiões' };
    }
};

export default {
    getRegioes,
    getRegiaoById,
    createRegiao,
    updateRegiao,
    deleteRegiao,
    listar
};
